class ViewBox {
    constructor(x0, y0, dx, dy) {
        this._viewBox = [x0, y0, dx, dy];
    }
    toString() {
        return this._viewBox.join(" ");
    }
}
export default ViewBox;
